:host {
  display: block;
  background-color: #fff;
  --textarea-padding: 0;
  --field-padding: 0;
  --textarea-line-height: 24px;
  --radio-label-height: 24px;
  --checkbox-label-height: 24px;
  position: relative;
}

.quark-form-item__wrapper {
  display: flex;
  padding: 10px 0;
  margin: 0 16px;
}

.quark-form-item__label-wrapper {
  flex-shrink: 0;
  margin-right: 12px;
  font-size: var(--cell-title-font-size, 14px);
  color: #5a6066;
  line-height: 24px;
}

.quark-form-item__label-wrapper .quark-form-item__label {
  display: inline-block;
  width: 100%;
}

.is-required .quark-form-item__label::before {
  content: '*';
  color: #f00;
  margin-right: 4px;
}

.is-no-asterisk .quark-form-item__label::before {
  display: none;
}

.quark-form-item__main {
  flex: 1;
}

.quark-form-item__main-content {
  min-height: 24px;
  /* display: flex;
  align-items: center; */
}

.quark-form-item_error-msg {
  color: #f00;
  font-size: 12px;
  line-height: 24px;
}

.quark-form-item__suffix {
  margin-left: 4px;
  flex-shrink: 0;
}

.quark-form-item__is-link {
  display: flex;
  align-items: center;
}